import React from "react";
import { EmailInput } from "@msidentity/SISU/components/inputs/email-input";
import { InputFabric as Input } from "@msidentity/SISU/components/inputs/input/fabric/input-fabric";
import StylesConfigFabric from "@msidentity/SISU/config/styles-config";
import { replaceTokens } from "@msidentity/SISU/utilities/strings-helper";
import { usernameRecoverySelectAliasStringsFabric } from "../../../fabric/username-recovery-strings-fabric";
import {
  type RecoveryAlias,
  UsernameRecoveryResultAliasType,
} from "../../../username-recovery-types";

type RecoveryAliasVerificationInputProps = {
  selectedRecoveryAlias: RecoveryAlias;
  index: number;
  aliasInputValue: string;
  handleAliasInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  error: string;
  isMultipleAliases: boolean;
};

/**
 *
 * @param param props for verification input
 * @param param.selectedRecoveryAlias selected alias for verification
 * @param param.index index of the alias
 * @param param.aliasInputValue value of the alias input
 * @param param.handleAliasInputChange function to handle alias input change
 * @param param.error error message
 * @param param.isMultipleAliases flag to indicate if there are multiple aliases
 * @returns component for verification input
 */
const RecoveryAliasVerificationInput: React.FC<RecoveryAliasVerificationInputProps> =
  function RecoveryAliasVerificationInput({
    selectedRecoveryAlias,
    index,
    aliasInputValue,
    handleAliasInputChange,
    error,
    isMultipleAliases,
  }) {
    const isMaskedAlias = !selectedRecoveryAlias.isUnmasked;
    const { useCommonStyles } = StylesConfigFabric.instance;
    const commonStyles = useCommonStyles();

    if (selectedRecoveryAlias.type === UsernameRecoveryResultAliasType.Email) {
      return (
        <div className={commonStyles.row}>
          {isMultipleAliases && isMaskedAlias && (
            <p>{usernameRecoverySelectAliasStringsFabric.emailAliasVerifyHint}</p>
          )}
          <EmailInput
            id={`recoveryAliasInput${index}`}
            name="recoveryAliasPickerEmail"
            placeholder={usernameRecoverySelectAliasStringsFabric.emailInputPlaceholder}
            type="text"
            value={aliasInputValue}
            onChange={handleAliasInputChange}
            externalError={error}
            showErrorInline
            hasInitialFocus={!isMultipleAliases}
            maxLength={113}
          />
        </div>
      );
    }

    const phoneAliasVerifyHint = replaceTokens(
      usernameRecoverySelectAliasStringsFabric.phoneAliasVerifyHint,
      "4",
    );
    return (
      <div className={commonStyles.row}>
        {isMultipleAliases && isMaskedAlias && <p>{phoneAliasVerifyHint}</p>}
        <Input
          id={`recoveryAliasInput${index}`}
          name="recoveryAliasPickerPhone"
          placeholder={replaceTokens(
            usernameRecoverySelectAliasStringsFabric.enterPhoneDigits,
            "4",
          )}
          type="text"
          value={aliasInputValue}
          maxLength={4}
          hasInitialFocus={!isMultipleAliases}
          onChange={handleAliasInputChange}
          errorMessage={error}
        />
      </div>
    );
  };

export default RecoveryAliasVerificationInput;
